<template>
  <div id="locker">
    <h1>Locker</h1>
    <NeedsReview v-if="!isDummyUser" />
    <ArtRequest v-if="!isDummyUser" />
    <SavedDesigns />
    <Roster v-if="!isDummyUser" />
    <Submissions v-if="!isDummyUser" />
    <OrderHistory v-if="!isDummyUser" />
    <NeedsLogged v-if="isDummyUser" />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import SavedDesigns from '@/components/Front/locker/SavedDesigns'
import Roster from '@/components/Front/locker/Roster'
import Submissions from '@/components/Front/locker/Submissions'
import NeedsReview from '@/components/Front/locker/NeedsReview'
import OrderHistory from '@/components/Front/locker/OrderHistory'
import NeedsLogged from '@/components/Front/locker/NeedsLogged'
import ArtRequest from '@/components/Front/locker/ArtRequest'
import { namespace } from 'vuex-class'
const manageUserStore = namespace('manageUserStore')

@Component({
  components: {
    SavedDesigns,
    Roster,
    Submissions,
    NeedsReview,
    OrderHistory,
    NeedsLogged,
    ArtRequest
  }
})
export default class Locker extends Vue {
  @manageUserStore.Action('setPrevUrl') actionSetPrevUrl
  created() {
    this.actionResetProductsLoaded()
    this.checkIfCanSeeLocker()
  }
  mounted() {
    this.saveUrl()
  }

  saveUrl() {
    this.actionSetPrevUrl(window.location.href)
  }

  mounted() {
    this.saveUrl()
  }

  saveUrl() {
    this.actionSetPrevUrl(window.location.href)
  }

  checkIfCanSeeLocker() {
    let canSeeLocker = false
    if (this.isRegisteredUser) {
      canSeeLocker = true
    }
    if (!canSeeLocker) {
      this.$router.push({ name: 'dashboard' })
    }
  }
}
</script>

<style lang="scss" scoped>
#locker {
  padding-top: 20px;

  > div {
    padding: 40px 0;
  }

  /deep/ {
    > div {
      > .header {
        align-items: flex-end;
        border-bottom: 3px solid black;
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        padding-bottom: 20px;

        h2 {
          line-height: 20px;
          margin: 0;
        }

        .btn-add {
          align-items: center;
          display: flex;
          justify-content: space-between;
          max-width: 234px;
          padding: 14px 18px 10px 23px;

          .plusIcon {
            font-size: 18px;
            font-weight: normal;
          }
        }
      }

      > .description {
        color: #202020;
        font-size: rem(15px);
        font-weight: 500;
        letter-spacing: 0.11px;
        margin-bottom: 43px;
      }

      .boldText {
        font-weight: bold;
      }
      .adjustCell {
        max-width: 180px;
      }
      table.vgt-table tbody tr.bb-data-table-row {
        &:hover {
          background-color: #f5f6fe;
          .boldText {
            color: #1324da;
          }
        }
      }
    }
  }
}
</style>
